export var ResolutionType;
(function (ResolutionType) {
    ResolutionType[ResolutionType["None"] = 0] = "None";
    ResolutionType[ResolutionType["Resolved"] = 1] = "Resolved";
    ResolutionType[ResolutionType["Ignored"] = 2] = "Ignored";
})(ResolutionType || (ResolutionType = {}));
